import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import moment from 'moment';
import {Popup, Button} from 'semantic-ui-react';
import keycloakConnector from '../../service/keycloak';
import {reduxStore} from '../../store';
import {Actions} from '../../actions';
import {dateFormatLogin} from '../../constants/datesFormat';
import MainMenu from '../../menu/components/newMenu';
import './appBar.scss';

class AppBar extends Component {
  onLogoutClick() {
    keycloakConnector.logout(reduxStore);
  }

  render() {
    const {user, currentLoginDate, lastLoginDate} = this.props;
    return (
      <div className='app-bar'>
        <div className='main-info'>
          <div className='brand-logo'>
            <Link to='/'>
              <img src='/media/logo.png' alt='Toyota' />
            </Link>
          </div>
          <div className='menu-container'>
            <MainMenu />
          </div>
          <div className='user-info'>
            <Popup
              trigger={this.renderUserPicture()}
              content={
                <div>
                  <Button
                    content='Logout'
                    icon='log out'
                    labelPosition='left'
                    onClick={this.onLogoutClick.bind(this)}
                  />
                </div>
              }
              position='left center'
              hoverable
            />
            <div className='text-info'>
              <div className='user-name'>{user ? user : 'Usuario Actual'}</div>
              <div className='current-date'>{currentLoginDate}</div>
              <div className='last-access'>Último Acceso: {lastLoginDate}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderUserPicture() {
    const {loadingUserInfo, photo} = this.props;
    if (!loadingUserInfo) {
      return (
        <img
          src={photo ? `data:image/png;base64,${photo}` : '/media/user.png'}
          alt='User'
        />
      );
    }

    return <img src='/media/user.png' alt='User' />;
  }
}

const mapStateToProps = (state) => {
  if (Object.keys(state).length > 0) {
    const loadingUserInfo = state.session.loadingUserInfo;
    const userName = state.session.userName;
    const userLastName = state.session.userLastName || '';
    const userPhoto = state.session.photo;

    const currentLoginDate = state.session.currentLoginDate;
    const currentLoginDateFormatted = currentLoginDate ?
      moment.unix(currentLoginDate).format(dateFormatLogin) :
      '';

    const lastLoginDate = state.session.lastLoginDate;
    const lastLoginDateFormatted = lastLoginDate ?
      moment(lastLoginDate).format(dateFormatLogin) :
      'Sin accesos previos';

    return {
      'user': `${userName} ${userLastName}`,
      'photo': userPhoto,
      'currentLoginDate': currentLoginDateFormatted,
      'lastLoginDate': lastLoginDateFormatted,
      'loadingUserInfo': loadingUserInfo,
    };
  }
};

const {logout} = Actions;

export default connect(mapStateToProps, {logout})(AppBar);
